import React, { useState } from 'react';
import api from '../api'; // <-- use your axios instance that attaches token

export default function BudgetPlanner() {
  const [month, setMonth] = useState('');
  const [income, setIncome] = useState('');
  const [expenses, setExpenses] = useState('');
  const [suggestion, setSuggestion] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const calculateBudget = async () => {
    setSuggestion('');
    setError('');
    setLoading(true);

    if (!month || !income || !expenses) {
      setError('Please fill in all fields.');
      setLoading(false);
      return;
    }

    const incomeVal = parseFloat(income);
    const expensesVal = parseFloat(expenses);

    if (isNaN(incomeVal) || isNaN(expensesVal)) {
      setError('Please enter valid numbers for income and expenses.');
      setLoading(false);
      return;
    }

    try {
      const response = await api.post('/budget/suggestions/', {
        income: incomeVal,
        expenses: expensesVal,
      });

      if (response.data && response.data.suggestions) {
        setSuggestion(response.data.suggestions);
      } else {
        setError('No suggestion received from the server.');
      }
    } catch (err) {
      console.error(err);
      if (err.response && err.response.status === 401) {
        setError('Unauthorized. Please log in again.');
      } else {
        setError('Failed to fetch AI suggestions. Check your backend or API key.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Budget Planner</h1>

      <label style={styles.label}>
        Select Month
        <input
          type="month"
          value={month}
          onChange={(e) => setMonth(e.target.value)}
          style={styles.input}
        />
      </label>

      <label style={styles.label}>
        Monthly Income
        <input
          type="number"
          placeholder="Monthly Income"
          value={income}
          onChange={(e) => setIncome(e.target.value)}
          style={styles.input}
        />
      </label>

      <label style={styles.label}>
        Monthly Expenses
        <input
          type="number"
          placeholder="Monthly Expenses"
          value={expenses}
          onChange={(e) => setExpenses(e.target.value)}
          style={styles.input}
        />
      </label>

      <button
        onClick={calculateBudget}
        disabled={!month || !income || !expenses || loading}
        style={{
          ...styles.button,
          opacity: !month || !income || !expenses || loading ? 0.6 : 1,
          cursor: !month || !income || !expenses || loading ? 'not-allowed' : 'pointer',
        }}
      >
        {loading ? 'Analyzing...' : 'Analyze'}
      </button>

      {suggestion && (
        <div style={styles.suggestionBox}>
          <strong>AI Suggestion:</strong>
          <p>{suggestion}</p>
        </div>
      )}

      {error && <p style={styles.errorText}>{error}</p>}
    </div>
  );
}

const styles = {
  container: {
    maxWidth: '500px',
    margin: '2rem auto',
    padding: '1.5rem',
    backgroundColor: '#fefefe',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  heading: {
    textAlign: 'center',
    marginBottom: '1.5rem',
    color: '#333',
    fontSize: '2rem',
  },
  label: {
    display: 'block',
    marginBottom: '1rem',
    fontWeight: '600',
    color: '#555',
  },
  input: {
    display: 'block',
    width: '100%',
    padding: '0.5rem 0.75rem',
    fontSize: '1rem',
    marginTop: '0.3rem',
    borderRadius: '4px',
    border: '1px solid #ccc',
    boxSizing: 'border-box',
  },
  button: {
    width: '100%',
    padding: '0.75rem',
    fontSize: '1.1rem',
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    fontWeight: '600',
    transition: 'background-color 0.3s ease',
  },
  suggestionBox: {
    marginTop: '1.5rem',
    backgroundColor: '#e6f4ea',
    border: '1px solid #a2d5a1',
    borderRadius: '6px',
    padding: '1rem',
    color: '#2f6f33',
  },
  errorText: {
    marginTop: '1rem',
    color: '#d9534f',
    fontWeight: '600',
  },
};
